<template>
	<div class='jdy-loading-box'>
		<div class='jdy-loading'>
			<span class='jdy-loading-inner'>
				<i class="el-icon-loading text-blue"></i>
				<span class='text-info-shallow-more'><slot>正在加载，请稍后...</slot></span>
			</span>
		</div>
	</div>
</template>
<script>
	export default {
		name:'loading'
	}
</script>



// WEBPACK FOOTER //
// src/components/loading.vue